<div class="lending-doc-container">
  @if (status) {
    <div [ngClass]="{'alert-success': status === 'SUCCESS', 'alert-error': status !== 'SUCCESS'}" class="alert">
      {{ message }}
    </div>
  }

  @if (isLoading) {
    <div class="loading-spinner">
      <p>Preparing your documents for download...</p>
    </div>
  }

  @if (!isLoading && !status) {
    <div class="download-initiated">
      <p>Your documents are being downloaded as a ZIP file.</p>
    </div>
  }
</div>
